import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { InputTextarea } from "primeng/inputtextarea";
import { ChatDetailComponent } from "./detail/chat-detail.component";
import { ButtonModule } from "primeng/button";
import { CommonModule, DatePipe } from "@angular/common";
import { TooltipModule } from "primeng/tooltip";
import { ChatListComponent } from "./list/chat-list.component";
import { CardModule } from "primeng/card";
import { TabViewModule } from "primeng/tabview";
import { ChatRoutingModule } from "./chat-routing.module";

import { CoreModule } from 'src/app/core/core.module';
@NgModule({
    declarations: [
        ChatDetailComponent,
        ChatListComponent
    ],
    imports: [
    CoreModule,
        ChatRoutingModule,
        CommonModule,
        FormsModule,
        InputTextModule,
        InputTextarea,
        ButtonModule,
        DatePipe,
        TooltipModule,
        CardModule,
        TabViewModule
    ],
    exports: [
        ChatDetailComponent,
        ChatListComponent
    ],
    providers: []
})
export class ChatModule { }
